import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <i className="fas fa-camera"></i>
              <span>Hemarose Pictures & Badges</span>
            </div>
            <p>Quality pictures, badges, and clothing at Line 3 Ahia Ohuru/New Market. We provide excellent products and reliable delivery services across Nigeria.</p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="#" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Professional Pictures</a></li>
              <li><a href="#services">Custom Badges</a></li>
              <li><a href="#services">New Clothing</a></li>
              <li><a href="#services">Waybill Services</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>Line 3 Ahia Ohuru/New Market</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <span>08063826436</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <span>info@hemarosepictures.com</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Hemarose Pictures & Badges. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;